import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import UpdateOuProperties from './update_ou_form';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { getOneOu } from 'redux/slices/getChildOu';
import { useDispatch, useSelector } from 'react-redux';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';

export default function UpdateouPropertiesModal({ ...record }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleOuData, setSingleOuData] = useState(null);
  const selectedNode = useSelector((state) => state.selectedNode);

  const showModal = async () => {
    try {
      setLoading(true);
      const sweetAlert = await dispatch(getOneOu({ ou: record.dnName, fqdn: selectedNode.domainName }));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        setSingleOuData(sweetAlert.payload.data);
        setOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title='Update' color='#597081' className='af-ou-edit-tooltip'>
        <SpanButton className='af-ou-edit-tooltip-button' onClick={showModal}>
          <EditIcon className='af-ou-edit-tooltip-icon' />
        </SpanButton>
      </Tooltip>
      {loading && <ModalOpenLoader />}
      {open && (
        <Modal
          open={open}
          maskClosable={false}
          onCancel={handleCancel}
          footer={[null]}
          centered
          width={800}
          className='modal-style af-ou-edit-modal'
        >
          <UpdateOuProperties {...record} singleOuData={singleOuData} handleCancel={handleCancel} />
        </Modal>
      )}
    </>
  );
}
